import { FC } from 'react'
// import { I18nextProvider } from "react-i18next";
// import i18n from "../shared/translations/i18n";
import { RecoilRoot as GlobalState } from 'recoil'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MemoryRouter } from 'react-router-dom'

type Props = {
  children?: React.ReactNode
}

const Providers: FC<Props> = ({ children }) => {
  const queryClient = new QueryClient()

  return (
    // <I18nextProvider i18n={i18n}>
    <GlobalState>
      <QueryClientProvider client={queryClient}>
        <MemoryRouter>{children}</MemoryRouter>
      </QueryClientProvider>
    </GlobalState>
    // </I18nextProvider>
  )
}

export default Providers
